<template lang="pug">
  b-modal#editProviderGameOff(
  ref="editProviderGameOff"
  :title="$t('ui.combine.edit_provider_game_off')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      div.row.mb-2
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.provider_code')" disabled).mb-0
            DebounceInput(
              size="sm"
              ref="provider_code"
              required
              type="text"
              :dirty="$v.provider_code.$dirty"
              :error="$v.provider_code.$error"
              v-model.trim.lazy="$v.provider_code.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.provider_code" :name="$t('ui.provider_code')")
        div.col-sm-12.col-md-4.col-lg-4
          b-form-group(:label="$t('ui.provider_name')" disabled).mb-0
            DebounceInput(
              size="sm"
              ref="provider_name"
              required
              type="text"
              :dirty="$v.provider_name.$dirty"
              :error="$v.provider_name.$error"
              v-model.trim.lazy="$v.provider_name.$model"
              :disabled="loading"
            )
            ValidateResult(:value="$v.provider_name" :name="$t('ui.provider_name')")
      div.row
        div.col-sm-12.col-md-6.col-lg-6
          //- div.row
          //-   div.col-md-2
          //-     b-input-group(size="sm")
          //-       b-input(:value="filterGameListLength" readonly)
          //-   div.col-md-6
          //-     b-input-group(size="sm")
          //-       b-input-group-text(slot="prepend")
          //-         i.fas.fa-search
          //-       DebounceInput(required type="text" v-model="gameListSearch").mr-1
          //-       b-form-radio-group(
          //-         buttons
          //-         v-model="gameListFilterBy"
          //-         size="sm"
          //-         button-variant="outline-info"
          //-       )
          //-         b-form-radio(value="id") {{ $t("ui.id") }}
          //-         b-form-radio(value="name") {{ $t("ui.name") }}
          b-form-group(:label="$t('ui.game_list')" style="overflow: hidden scroll; height: 40vh;").mb-3
            div.row.mb-3.animated.fadeIn
              div.col
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.text-center.sticky-position(width="10%")
                        span &nbsp;
                      th.sticky-position(width="40%")
                        span(:title="$t('ui.game_id')") {{ $t("ui.game_id") }}
                      th.sticky-position(width="50%")
                        span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                  tbody.clusterize-content
                    tr(v-if="filterGameList.length == 0")
                      td(colspan="3").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filterGameList")
                      td.actions.text-center
                        span
                          a.fa.fa-plus.text-success(href="#" @click="onAdd(item)" :ttile="$t('ui.add')")
                      td
                        span(:title="item[game_id_field]") {{ item[game_id_field] }}
                      td
                        span(:title="item[game_name_field]['en-US']" v-if="provider_code == 'JILI'") {{ item[game_name_field]['en-US'] }}
                        span(:title="item['Value'][game_name_field]" v-else-if="provider_code == 'FC'") {{ item['Value'][game_name_field] }}
                        span(:title="item[game_name_field]" v-else) {{ item[game_name_field] }}
        div.col-sm-12.col-md-6.col-lg-6
          //- div.row
          //-   div.col-md-2
          //-     b-input-group(size="sm")
          //-       b-input(:value="filterOffListLength" readonly)
          //-   div.col-md-6
          //-     b-input-group(size="sm")
          //-       b-input-group-text(slot="prepend")
          //-         i.fas.fa-search
          //-       DebounceInput(required type="text" v-model="offListSearch").mr-1
          //-       b-form-radio-group(
          //-         buttons
          //-         v-model="offListFilterBy"
          //-         size="sm"
          //-         button-variant="outline-info"
          //-       )
          //-         b-form-radio(value="id") {{ $t("ui.id") }}
          //-         b-form-radio(value="name") {{ $t("ui.name") }}
          b-form-group(:label="$t('ui.off_list')" style="overflow: hidden scroll; height: 40vh;").mb-3
            div.row.mb-3.animated.fadeIn
              div.col
                table.tablex(style="width: 100%;")
                  thead
                    tr
                      th.text-center.sticky-position(width="10%")
                        span &nbsp;
                      th.sticky-position(width="40%")
                        span(:title="$t('ui.game_id')") {{ $t("ui.game_id") }}
                      th.sticky-position(width="50%")
                        span(:title="$t('ui.game_name')") {{ $t("ui.game_name") }}
                  tbody.clusterize-content
                    tr(v-if="filterOffList.length == 0")
                      td(colspan="3").text-center
                        span {{ $t('message.no_data_available') }}
                    tr(v-for="(item, index) in filterOffList")
                      td.actions.text-center
                        span
                          a.fa.fa-trash.text-danger(href="#" @click="onRemove(item)" :ttile="$t('ui.remove')")
                      td
                        span(:title="item.game_id") {{ item.game_id }}
                      td
                        span(:title="item.game_name") {{ item.game_name }}
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      offList: [],
      providerGameList: [],
      provider_code: '',
      provider_name: '',
      game_id_field: '',
      game_name_field: '',
      loading: false,
      feedback: {
        success: true,
        status: ""
      },
      gameListFilterBy: "name",
      gameListSearch: "",
      offListFilterBy: "name",
      offListSearch: "",
      mapName: false,
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    filterGameListLength() {
      if (this.filterGameList) {
        return this.filterGameList.length;
      } else {
        return 0;
      }
    },
    filterOffListLength() {
      if (this.filterOffList) {
        return this.filterOffList.length;
      } else {
        return 0;
      }
    },
    filterGameList() {
      var freeList = this.providerGameList;
      var groupList = this.offList;
      var list = [];

      for(var i = 0; i < freeList.length; i++) {
        var temp = groupList.filter(item => {
          return item.game_id == freeList[i][this.game_id_field];
        })

        if (temp.length == 0) {
          list.push(freeList[i]);
        }
      }

      // list = list.filter(item => {
      //   if (this.gameListFilterBy == "id") return item[this.game_id_field].toLowerCase().indexOf(this.gameListSearch.toLowerCase()) > -1;
      //   // else if (this.gameListFilterBy == "name") return item[this.game_name_field].toLowerCase().indexOf(this.gameListSearch.toLowerCase()) > -1;
      // }).sort((a, b) => {
      //   return a[this.game_id_field] > b[this.game_id_field] ? 1 : -1;
      // });

      return list;
    },
    filterOffList() {
      var oList = this.offList;
      var pList = this.providerGameList;

      for(var i = 0; i < oList.length; i++) {
        var obj = pList.filter(item => { return item[this.game_id_field] == oList[i].game_id });
        if (obj.length != 0) {
          if (this.provider_code == 'JILI')
            oList[i].game_name = obj[0][this.game_name_field]['en-US'];
          else if (this.provider_code == 'FC')
            oList[i].game_name = obj[0]['Value'][this.game_name_field];
          else
            oList[i].game_name = obj[0][this.game_name_field];

        }
      }

      return oList;
      // return this.offList.filter(item => {
      //   if (this.offListFilterBy == "id") return item.game_id.toLowerCase().indexOf(this.offListSearch.toLowerCase()) > -1;
      //   // else if (this.offListFilterBy == "name") return item.game_name.toLowerCase().indexOf(this.offListSearch.toLowerCase()) > -1;
      // })
      // .sort((a, b) => {
      //   return a['game_id'] > b['game_id'] ? 1 : -1;
      // });
    }
  },
  validations: {
    provider_code: {
      required
    },
    provider_name: {
      required,
      alphaNum
    },
  },
  methods: {
    onAdd: function(e) {
      let url = config.providerGameOffAddUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        provider_code: this.item.provider_code,
        game_id: e[this.game_id_field],
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderGameOffList();
                this.getGameList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    onRemove: function(e) {
      let url = config.providerGameOffRemoveUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        provider_code: this.item.provider_code,
        game_id: e.game_id,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getProviderGameOffList();
                this.getGameList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getProviderGameOffList: function() {
      let url = config.providerGameOffListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        provider_code: this.item.provider_code
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.offList = response.data.dt;
                // this.getGameList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getGameList: function() {
      let url = "";
      var json = {
        lang_code: "en"
      };

      if (this.provider_code.trim().toUpperCase() == 'EPIC') url = config.getGameList["epicUrl"];
      else if (this.provider_code.trim().toUpperCase() == 'EPIC2') url = config.getGameList["epic2Url"];
      else if (this.provider_code.trim().toUpperCase() == 'LIVE22') url = config.getGameList["live22Url"];
      else if (this.provider_code.trim().toUpperCase() == 'CQ9') url = config.getGameList["cq9Url"];
      else if (this.provider_code.trim().toUpperCase() == 'HBNR') url = config.getGameList["habaneroUrl"];
      else if (this.provider_code.trim().toUpperCase() == 'PP-S') url = config.getGameList["ppsUrl"];
      else if (this.provider_code.trim().toUpperCase() == 'PP-S123') url = config.getGameList["pps123Url"];
      else if (this.provider_code.trim().toUpperCase() == 'YGR') url = config.getGameList["ygrUrl"];
      else if (this.provider_code.trim().toUpperCase() == 'MEGAH5') url = config.getGameList["megah5Url"];
      else if (this.provider_code.trim().toUpperCase() == 'WOW') url = config.getGameList["wowUrl"];
      else if (this.provider_code.trim().toUpperCase() == 'FC') {
        url = config.getGameList["fcUrl"];
        json.gametype = "slot";
      }
      else if (this.provider_code.trim().toUpperCase() == 'JILI2') {
        url = config.getGameList["jili2Url"];
        json.game_category = "1";
      }
      else if (['JILI','PG','FASTSPIN','YESBINGO','JDB'].includes(this.provider_code.trim().toUpperCase())) {
        url = config.getGameList["awcUrl"];
        json.gametype = "SLOT";
        json.platform = this.provider_code.trim().toUpperCase();
      }
      else if (['MG','SPNX','SPDG','BG','HSG','RG','EVOP','PNG','EVONTT','EVORT','EVOBTG','EVONLC','BNG','AP','ALG','SPB','HSD'].includes(this.provider_code.trim().toUpperCase())) {
        url = config.getGameList["oneUrl"];
        json.gametype = "SLOT";
        json.platform = this.provider_code.trim().toUpperCase();
      }

      if (url != "") {
        // this.mapName = false;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (["EPIC", "LIVE22", "EPIC2", "MEGAH5"].includes(this.provider_code.trim().toUpperCase())) {
                  this.feedback.success = typeof response.data.Status == "string" ? response.data.Status == "200" : response.data.Status == 200;
                  this.feedback.status = response.data.Description;
                }
                else if (['JILI','FC','PG','FASTSPIN','YESBINGO','JDB','JILI2','MG','SPNX','SPDG','BG','HSG','RG','EVOP','PNG','EVONTT','EVORT','EVOBTG','EVONLC','BNG','AP','ALG','SPB','PP-S123','HSD','YGR','WOW'].includes(this.provider_code.trim().toUpperCase())) {
                  this.feedback.success = typeof response.status == "string" ? response.status == "200" : response.status == 200;
                  this.feedback.status = response.statusText;
                }
                else {
                  this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
                  this.feedback.status = response.data.statusdesc;
                }

                if (this.feedback.success == true) {
                  if (['EPIC','LIVE22','EPIC2','MEGAH5'].includes(this.provider_code.trim().toUpperCase())) this.providerGameList = response.data.Game;
                  else if (['HBNR','CQ9'].includes(this.provider_code.trim().toUpperCase())) this.providerGameList = response.data.game_list;
                  else if (['JILI','FC','PG','FASTSPIN','YESBINGO','JDB','JILI2','PP-S','MG','SPNX','SPDG','BG','HSG','RG','EVOP','PNG','EVONTT','EVORT','EVOBTG','EVONLC','BNG','AP','ALG','SPB','PP-S123','HSD','YGR','WOW'].includes(this.provider_code.trim().toUpperCase())) this.providerGameList = response.data;
                  // this.mapGameNameOffList();
                  // console.log(this.providerGameList[0]['Value']['gameNameOfEnglish'])


                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
    },
    // mapGameNameOffList: function() {
    //   var oList = this.offList;
    //   var pList = this.providerGameList;

    //   for(var i = 0; i < oList.length; i++) {
    //     var obj = pList.filter(item => { return item[this.game_id_field] == oList[i].game_id });
    //     if (obj.length != 0) {
    //       this.offList[i].game_name = obj[0][this.game_name_field];
    //     }
    //   }
    // },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.provider_code = this.item.provider_code;
      this.provider_name = this.item.provider_name;
      this.game_id_field = config.gameIdField[this.provider_code];
      this.game_name_field = config.gameNameField[this.provider_code];
      // console.log(this.game_id_field, this.game_name_field)
      this.offList = [];
      this.providerGameList = [];
      this.getProviderGameOffList();
      this.getGameList();
    }
  }
};
</script>
